// Centralize embedded-admin app URL helpers so the app handle fallback stays
// consistent even when REACT_APP_SHOPIFY_APP_HANDLE is not injected at build time.
// We also cache the resolved shop handle because embedded app routes often drop
// the original `shop` query param after navigation.
const DEFAULT_SHOPIFY_APP_HANDLE = "partfinder-development";
const SHOPIFY_STORE_HANDLE_KEY = "shopify-store-handle";
const SHOPIFY_APP_HANDLE_KEY = "shopify-app-handle";

function normalizeShopHandle(value?: string | null): string {
    const trimmed = value?.trim();
    if (!trimmed) return "";

    return trimmed
        .replace(/^https?:\/\//i, "")
        .split("/")[0]
        .replace(/\.myshopify\.com$/i, "")
        .trim()
        .toLowerCase();
}

function cacheShopHandle(handle: string): string {
    if (handle) {
        window.sessionStorage.setItem(SHOPIFY_STORE_HANDLE_KEY, handle);
    }

    return handle;
}

function getShopifyStoreHandleFromAdminPath(): string {
    const host = window.location.hostname.toLowerCase();

    if (host === "admin.shopify.com") {
        const segments = window.location.pathname.split("/").filter(Boolean);
        const storeIndex = segments.findIndex((segment) => segment.toLowerCase() === "store");
        const storeHandle = storeIndex >= 0 ? segments[storeIndex + 1] : "";
        return normalizeShopHandle(storeHandle ? decodeURIComponent(storeHandle) : "");
    }

    if (host.endsWith(".myshopify.com")) {
        return normalizeShopHandle(host);
    }

    return "";
}

export function getShopifyAppHandle(): string {
    return window.sessionStorage.getItem(SHOPIFY_APP_HANDLE_KEY)
        || process.env.REACT_APP_SHOPIFY_APP_HANDLE
        || DEFAULT_SHOPIFY_APP_HANDLE;
}

export function setShopifyAppHandle(appHandle?: string | null): void {
    if (appHandle) {
        window.sessionStorage.setItem(SHOPIFY_APP_HANDLE_KEY, appHandle);
    }
}

export function getShopifyStoreHandle(shopDomain?: string | null): string {
    if (shopDomain) {
        return cacheShopHandle(normalizeShopHandle(shopDomain));
    }

    const params = new URLSearchParams(window.location.search);
    const urlShop = params.get("shop");
    if (urlShop) {
        return cacheShopHandle(normalizeShopHandle(urlShop));
    }

    const adminPathShopHandle = getShopifyStoreHandleFromAdminPath();
    if (adminPathShopHandle) {
        return cacheShopHandle(adminPathShopHandle);
    }

    return window.sessionStorage.getItem(SHOPIFY_STORE_HANDLE_KEY) || "";
}
